import { render, staticRenderFns } from "./CertificatTypeItem.vue?vue&type=template&id=086abebe&scoped=true&"
import script from "./CertificatTypeItem.vue?vue&type=script&lang=js&"
export * from "./CertificatTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./CertificatTypeItem.vue?vue&type=style&index=0&id=086abebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086abebe",
  null
  
)

export default component.exports